
/* GZ Lures - Legacy filter accordion compatibility */

document.addEventListener('click', function (event) {
  const button = event.target.closest(
    '.productgrid--sidebar-group [data-filter-group-trigger]'
  );

  if (!button) return;

  const group = button.closest('.productgrid--sidebar-group');
  if (!group) return;

  const content = group.querySelector('[data-accordion-content]');
  if (!content) return;

  const isOpen = window.getComputedStyle(content).display !== 'none';
  const nextOpen = !isOpen;

  content.style.display = nextOpen ? '' : 'none';

  button.setAttribute('aria-expanded', String(nextOpen));
  content.setAttribute('aria-expanded', String(nextOpen));
});

/* Start all legacy filter categories collapsed */

function gzCollapseFilterGroups() {
  document.querySelectorAll(
    '.productgrid--sidebar-group'
  ).forEach(function (group) {
    const content = group.querySelector('[data-accordion-content]');
    const button = group.querySelector('[data-filter-group-trigger]');

    if (!content || !button) return;

    content.style.display = 'none';
    button.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-expanded', 'false');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', gzCollapseFilterGroups);
} else {
  gzCollapseFilterGroups();
}

/* GZ Lures - Legacy filter See More / See Less */

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-filter-toggle]');
  if (!toggle) return;

  const group = toggle.closest('.productgrid--sidebar-group');
  if (!group) return;

  event.preventDefault();

  const expanded = toggle.getAttribute('data-filter-toggle') === 'true';

  group.querySelectorAll('.filter-item--hidden').forEach(function (item) {
    item.style.display = expanded ? '' : 'list-item';
  });

  toggle.setAttribute('data-filter-toggle', String(!expanded));
  toggle.textContent = expanded ? 'See More' : 'See Less';
});
